import {Component, forwardRef, Input, OnInit} from "@angular/core";
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    selector: 'db-fc-switch',
    templateUrl: './fc-switch.component.html',
    styleUrls: ['./fc-switch.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FcSwitchComponent),
            multi: true,
        }
    ],
    standalone: false
})
export class FcSwitchComponent implements ControlValueAccessor, OnInit {

  @Input() formControl: FormControl;
  @Input() value: any;
  @Input() size: ''|'sm';
  @Input() color: 'info'|'success'|'warning'|'danger';
  @Input() inverted: boolean;

  private _propagateChange: Function = (_: any) => {};

  constructor() {}

  ngOnInit(): void {
    this.color = this.color || 'info';
  }

  writeValue(value: any): void {}

  registerOnChange(fn: any): void {
    this._propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState(isDisabled: boolean): void {}

  public onClick(): void {
    this._propagateChange(this.value);
  }

}
